<script setup>
import { getEnvURLs } from '../../../helpers/config';

const props = defineProps({
	// Per-event documents configured under "Login & Documents"
	// (eventData.settings.links), each { value, title, target? }.
	links: {
		type: Array,
		default: () => [],
	},
});

const docsBase = `${getEnvURLs().eco}/docs`;
const termsUrl = `${docsBase}/attendee-terms-of-use.pdf`;
const privacyUrl = `${docsBase}/privacy-notice.pdf`;
</script>

<template>
	<div class="auth-terms">
		<div class="auth-terms__agreement">
			By proceeding you agree to the
			<a :href="termsUrl" target="_blank" rel="noopener noreferrer" class="auth-terms__link">Terms of Service Agreement</a>
			and
			<a :href="privacyUrl" target="_blank" rel="noopener noreferrer" class="auth-terms__link">Privacy Notice</a>.
		</div>
		<div class="auth-terms__documents" v-if="props.links && props.links.length">
			<a v-for="link in props.links" :key="link.value" :href="link.value" :target="link.target || '_blank'"
				rel="noopener noreferrer" class="auth-terms__link">{{ link.title }}</a>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.auth-terms {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 6px;
	text-align: center;
	font-size: 12px;
	line-height: 18px;
	color: #4B444D;

	&__documents {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
	}

	&__link {
		color: #583174;
		text-decoration: none;
		font-weight: 600;

		&:hover {
			text-decoration: underline;
		}
	}
}
</style>
